import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Order} from '../../../dto/order';
import {byNumeric} from 'iso-country-codes';
import {Product} from '../../../dto/product';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.css']
})
export class OrderSummaryComponent implements OnInit {
  public _orderForm: Order;
  public _product: Product;

  constructor() { }

  ngOnInit(): void {
  }

  @Input()
  set orderForm(val: Order) {
    this._orderForm = val;

  }

  @Input()
  set product(val: Product) {
    this._product = val;

  }

}
